import { $deleteSignatureRequests, deleteSignatureRequests } from './actionCreators';
import reducer from './reducer';
import sagas from './sagas';

export default {
  sagas,
  reducer,
  actions: {
    deleteSignatureRequests,
  },
};

export const $actions = {
  deleteSignatureRequests: $deleteSignatureRequests,
};
